'use strict';

const _ = require('lodash');

const FormBuilder = require('./../../../services/form');
const SaveManager = require('./../component/SaveManager');
const zone = require('./../../../services/structure/zone');
const Translator = require('./../../../core/translator');
const Loader = require('./../../../services/loader');
const Notifier = require('./../../../services/notifier');
const container = require('./../../../core/container');
const mediator = require('./../../../core/mediator');

const contentScroller = require('./service/contentScroller');

let currentContent = null;

/**
 * Compute parameters for create form
 *
 * @param {object} content
 * @param {object} data
 * @returns {object} Form
 */
const buildForm = function(content, data) {
    let config = {};

    config.elements = {};
    config.form = {
        'submit_class': 'btn btn-default',
        'submit_label': Translator.translate('submit'),
    };

    _.forEach(content.data.parameters, function(value, key) {
        if (_.isString(value.type)) {
            if (data.params['current_tab'] && data.params['current_tab'] == value.tab) {
                value['tab_focus'] = true;
            }

            config.elements[key] = value;
        }
    });

    return FormBuilder.getForm(config);
};

/**
 * OnSubmit callback update parameters of content
 * save and refresh
 *
 * @param {object} form
 * @param {object} configData
 * @param {object} data
 */
const onSubmit = function(form, configData, data) {
    let content = form.content;

    form.dispatch('submit.parameters');

    content.setParameters(data);

    SaveManager.save().done(function() {
        content.refresh().done(function() {
            contentScroller.scroll(content);

            Notifier.success(Translator.translate('content_edited'));

            mediator.publish('after:' + content.type + ':submit:parameters', content);
            mediator.publish('after:submit:parameters', content);

            if (typeof configData.params.callback === 'function') {
                configData.params.callback(configData);
            }
        });

        zone.hidePanels();
    });
};

module.exports.onLayerClose = function() {
    if (currentContent) {
        contentScroller.scroll(currentContent);
        currentContent = null;
    }
};

module.exports.onClick = function(data) {
    let content = data.params.content;

    Loader.start();

    zone.setSmallPanel(Translator.translate('parameters'), '');

    if (content) {
        currentContent = content;

        content.getData().done(function() {
            let form = buildForm(content, data);

            form.listeners.cancel = [];
            form.listeners['submit.parameters'] = [];
            form.content = content;

            form.on('submit', onSubmit.bind(this, form, data));

            zone.setSmallPanel(Translator.translate('title_parameters') + ' ' + Translator.translate(content.getLabel()), form.render());
            zone.setFooter(container.get('$smallPanel'), zone.createSubmitButtons({
                onSubmitClick: form.submit.bind(form),
                onCancelClick: function() {
                    form.dispatch('cancel');

                    mediator.publish('menu:close');
                    contentScroller.scroll(content);

                    currentContent = null;

                    if (typeof data.params.callback === 'function') {
                        data.params.callback(data);
                    }
                },
            }));

            Loader.stop();
        });
    }
};
